import { render, staticRenderFns } from "./KBAutocompleteSmall.vue?vue&type=template&id=08fb235c&scoped=true&"
import script from "./KBAutocompleteSmall.vue?vue&type=script&lang=ts&"
export * from "./KBAutocompleteSmall.vue?vue&type=script&lang=ts&"
import style0 from "./KBAutocompleteSmall.vue?vue&type=style&index=0&id=08fb235c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb235c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
